
import { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../contexts/auth';

import logo from '../../logo.png'

function Login() {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const { signIn, loadingAuth } = useContext(AuthContext);

  function handleSubmit(e){
      e.preventDefault();
      //alert('clicou');
      //alert(email);
      if(email!=='' && password!==''){

        signIn(email, password)
      }


    }

  return (
    <div class="grid-container form-signin">

        <div className="grid-x grid-padding-x account-wall">
          <div className="large-12 small-12 medium-12 cell">
            <img className="profile-img" src={logo} alt="" />
            <form onSubmit={handleSubmit}>
              <input type="email" name="email" placeholder="Digite seu email" value={email} onChange={ (e) => setEmail(e.target.value) } required autofocus/>
              <input type="password" name="senha" placeholder="Digite sua senha" value={password} onChange={ (e) => setPassword(e.target.value) } required/>
              <button className="button expanded" type="submit">Acessar</button>
            </form>
          </div>
          <div className="large-12 small-12 medium-12 cell">
            <Link to="/login/recuperar-senha" className="new-account">Esqueceu sua senha?</Link>
          </div>
          <div className="large-12 small-12 medium-12 cell">
            <Link to="/comprar" className="new-account">Criar uma conta</Link>
          </div>
        </div>





    </div>

  );
}

export default Login;
